"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertAttachment = void 0;
const Attachment_1 = require("../model/Attachment");
const convertLinks_1 = require("./convertLinks");
const convertAttachment = (entity) => {
    return {
        id: entity.id,
        type: (0, Attachment_1.getAttachmentType)(entity.type),
        linkToResource: entity._links.download.href,
        description: entity.description,
        links: (0, convertLinks_1.convertLinks)(entity),
    };
};
exports.convertAttachment = convertAttachment;
//# sourceMappingURL=convertAttachment.js.map